const STAGE_CONFIG = [
  { label: "Opened Story", key: "opened" },
  { label: "Started scrolling", key: "started_reading" },
  { label: "Completed reading", key: "finished_reading" },
];

export const Skeleton = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {STAGE_CONFIG.map((stage) => (
        <div key={stage.key} className="tw-flex tw-flex-col tw-gap-2">
          {/* Stage name */}
          <span className="tw-font-sans tw-text-xs tw-font-normal tw-text-blue">
            {stage.label}
          </span>

          {/* Progress bar and data */}
          <div className="tw-flex tw-items-center tw-gap-6">
            {/* Progress bar */}
            <div className="tw-flex-1 tw-h-2 tw-rounded-full tw-bg-blue-100/50 tw-animate-skeleton-loading" />

            {/* Percentage and user count */}
            <span className="tw-w-20 tw-h-4 tw-flex tw-items-center tw-justify-end">
              <span className="tw-h-2 tw-w-16 tw-rounded-lg tw-bg-blue-100/50 tw-block" />
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
